import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popper, Paper, Button, Modal, Box, Typography } from "@mui/material";
import { AuthContext  } from "../../login/AuthContext";
import ModalConfigMenu from "../modales/ModalConfigMenu";

const CustomPopperNavBar = ({ open, anchorEl, cajamodal, handleClose }) => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);
  const popperRef = React.useRef(null);

  const handleOpenConfigModal = () => setIsConfigModalOpen(true);
  const handleCloseConfigModal = () => setIsConfigModalOpen(false);
  
  const handleOpenLogoutModal = () => setLogoutModalOpen(true);
  const handleCloseLogoutModal = () => setLogoutModalOpen(false);
  const handleCloseLogoutModal2 = () => {
    setLogoutModalOpen(false);
    logout();
    navigate('/');
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        anchorEl &&
        !anchorEl.contains(event.target) &&
        popperRef.current &&
        !popperRef.current.contains(event.target)
      ) {
        handleClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open, anchorEl, handleClose]);

  return (
    <>
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right-start"
      modifiers={[
        {
          name: "preventOverflow",
          options: {
            boundary: "window",
          },
        },
      ]}
      style={{ zIndex: 1300 }}
      ref={popperRef}
      >
      <Paper sx={{p: 2, boxShadow: 3, bgcolor: "#dfdfdf", borderRadius: 2, width: 150, }} >
        {cajamodal.map((boton, index) => (
          <Button
            key={index}
            data-key={boton.id}
            sx={{
              mt: 1,
              display: "block",
              width: "100%",
              fontSize: 12,
              lineHeight: 1.2,
              "&:hover": {
                bgcolor: "#d0e7ff", // Cambia el fondo al pasar el mouse
                color: "#0056b3", // Cambia el color del texto al pasar el mouse
              },
            }}
            variant="text"
              onClick={() => {
                if (boton.id === "ConfiguracionMenu") {
                  handleOpenConfigModal();
                }
                if (boton.id === "CerrarSesion") {
                  handleOpenLogoutModal();
                }
              }}
          >
            {boton.label}
          </Button>
        ))}
      </Paper>
    </Popper>
    <ModalConfigMenu
      open={isConfigModalOpen}
      handleClose={handleCloseConfigModal}
    />
    <Modal
        open={logoutModalOpen}
        onClose={handleCloseLogoutModal}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        >
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: 300, bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, p: 4, borderRadius: 2, }}
        >
          <Box mb={1} display="flex" justifyContent="center">
            <Typography id="logout-modal-title" variant="h6" component="h2">
            Cerrando Sesión
            </Typography>
          </Box>
            <Typography id="logout-modal-description" sx={{ mt: 2 }}>
            ¿Estás seguro que deseas salir de la aplicación?
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                    console.log("Sesión cerrada");
                    handleCloseLogoutModal2();
                }}
                sx={{ marginRight:2}}
            >
                Confirmar
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleCloseLogoutModal}>
                Cancelar
            </Button>
            </Box>
        </Box>
        </Modal>
    </>
  );
};

export default CustomPopperNavBar;
